import React, { ComponentType } from 'react';
import styles from './width.module.sass';

export const widthPresets = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
    xlarge: styles.xlarge,
    wider: styles.wider,
    fullPage: styles.full,
};

interface WithPresetWidthProps {
    presetWidth?: keyof typeof widthPresets;
    className?: string;
}

const withPresetWidth = <P extends object>(WrappedComponent: ComponentType<P>) => {
    const ComponentWithPresetWidth = (props: P & WithPresetWidthProps) => {
        const { presetWidth, className, ...restProps } = props;
        const presetClassName = presetWidth ? widthPresets[presetWidth] : '';
        const combinedClassName = [className, presetClassName].filter(Boolean).join(' ');

        return <WrappedComponent className={combinedClassName} {...(restProps as P)} />;
    };

    return ComponentWithPresetWidth;
};

export default withPresetWidth;
